
import { useGranjasQuery } from "../../../hooks";
import { BuscadorSoloValor, CargandoMedio, TablaListGranja } from "../../components";
import { DisenioPaginas } from "../../layout";



export const ListadoGranjas = () => {


    const { granjasListQuery, page, termino, chagePage, chageTermino } = useGranjasQuery()


    return (

        <DisenioPaginas titulo="Listado de Granjas" url="add/granja">

            {(granjasListQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Granjas..." />
            :   <>
                <BuscadorSoloValor termino={termino} chageTermino={chageTermino} 
                    titulo='Buscar granja...' place='Buscar x nombre...'
                />
                <TablaListGranja data={granjasListQuery.data || []} chagePage={chagePage} page={page} />
                </>
            }

        </DisenioPaginas>

    )
}
